import { Layout } from '@consta/uikit/Layout'
import { Modal } from '@consta/uikit/Modal'
import { Select } from '@consta/uikit/Select'
import { TextField } from '@consta/uikit/TextField'
import type { SeismicNamedBaseType } from '@core/core/types'
import type { Nullable } from 'common/types'
import type { FC } from 'react'
import { useEffect, useState } from 'react'

import css from './AddingFilesModal.css'
import { AddingFilesModalFooter as ModalFooter } from './AddingFilesModalFooter'
import { AddingFilesModalHeader as ModalHeader } from './AddingFilesModalHeader'
import type {
  AddingFilesAttributeModalPropsType as PropsType,
  FormDataAttributeType,
} from './types'

export const AddingFilesAttributeModal: FC<PropsType> = ({
  fileName,
  objectName,
  attributeItems,
  isModalOpen,
  onCancel,
  onSave,
}) => {
  const [formData, setFormData] = useState<FormDataAttributeType | undefined>()
  const isAttributeOther = formData?.attribute?.id === '0'
  const isNewAttributeObjectName = Boolean(formData?.newAttributeObjectName)
  const isNewAttribute = Boolean(!isAttributeOther || isNewAttributeObjectName)

  const onChangeField =
    (key: keyof FormDataAttributeType) => (value: Nullable<string | SeismicNamedBaseType>) => {
      setFormData(prev => ({
        ...prev,
        [key]: value,
      }))
    }

  useEffect(() => {
    setFormData({
      objectName: objectName ?? fileName,
      attribute: formData?.attribute ?? attributeItems[0],
      newAttributeObjectName: undefined,
    })
  }, [fileName])

  useEffect(() => {
    if (isNewAttribute) {
      const fn = onChangeField('newAttributeObjectName')
      fn(null)
    }
  }, [isAttributeOther])

  return (
    <Modal
      isOpen={isModalOpen}
      hasOverlay={true}
      rootClassName={css.rootContainer}
      className={css.window}
      onClickOutside={onCancel}
      onEsc={onCancel}>
      <ModalHeader fileName={fileName} />

      <Layout direction="column" className={css.surveyNamePart}>
        <TextField
          type="text"
          label="Название съемки"
          labelPosition="top"
          size="s"
          className={css.surveyNameInput}
          disabled={true}
          value={formData?.objectName}
          onChange={onChangeField('objectName')}
        />

        <Select
          placeholder="Выберите значение"
          label="Тип атрибута"
          className={css.surveyNameInput}
          size="s"
          dropdownClassName={css.selectDropdown}
          items={attributeItems}
          value={formData?.attribute}
          getItemKey={item => item.id}
          getItemLabel={item => item.name ?? ''}
          onChange={onChangeField('attribute')}
        />

        {!!isAttributeOther && (
          <TextField
            type="text"
            label="Название атрибута"
            labelPosition="top"
            size="s"
            className={css.surveyNameInput}
            value={formData.newAttributeObjectName}
            required={!isNewAttributeObjectName}
            onChange={onChangeField('newAttributeObjectName')}
          />
        )}
      </Layout>

      <ModalFooter
        isViewSaveAllBtn={false}
        isDisabledOnSaveBtn={!isNewAttribute}
        onSave={() => {
          onSave(formData)
        }}
        onCancel={onCancel}
      />
    </Modal>
  )
}
